import React, { useState } from "react";
import "./login.css";

const API = "/php";

const Login = ({ onLogin }) => {
    const [login, setLogin]       = useState("");
    const [password, setPassword] = useState("");
    const [error, setError]       = useState("");
    const [loading, setLoading]   = useState(false);
    const [showPass, setShowPass] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!login.trim() || !password.trim()) {
            setError("Заполните все поля");
            return;
        }
        setLoading(true);
        setError("");
        try {
            const res  = await fetch(`${API}/login.php`, {
                method:  "POST",
                headers: { "Content-Type": "application/json" },
                body:    JSON.stringify({ login, password })
            });
            const data = await res.json();
            if (data.ok) {
                localStorage.setItem("gps_token", data.token);
                onLogin();
            } else {
                setError(data.error || "Ошибка авторизации");
            }
        } catch {
            setError("Ошибка соединения с сервером");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-bg">
                <div className="login-bg-circle login-bg-circle1"></div>
                <div className="login-bg-circle login-bg-circle2"></div>
                <div className="login-bg-circle login-bg-circle3"></div>
            </div>

            <div className="login-card">
                <div className="login-logo">
                    <img src="logo.png" alt="GPS Billing" />
                </div>
                <h1 className="login-title">TMS Billing</h1>
                <p className="login-subtitle">Введите данные для входа</p>

                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="login-field">
                        <label>Логин</label>
                        <div className="login-input-wrap">
                            <i className="fas fa-user login-icon"></i>
                            <input
                                type="text"
                                placeholder="Введите логин"
                                value={login}
                                onChange={(e) => setLogin(e.target.value)}
                                autoComplete="username"
                            />
                        </div>
                    </div>

                    <div className="login-field">
                        <label>Пароль</label>
                        <div className="login-input-wrap">
                            <i className="fas fa-lock login-icon"></i>
                            <input
                                type={showPass ? "text" : "password"}
                                placeholder="Введите пароль"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoComplete="current-password"
                            />
                            <button
                                type="button"
                                className="login-eye"
                                onClick={() => setShowPass(!showPass)}
                                tabIndex={-1}
                            >
                                <i className={`fas ${showPass ? "fa-eye-slash" : "fa-eye"}`}></i>
                            </button>
                        </div>
                    </div>

                    {error && (
                        <div className="login-error">
                            <i className="fas fa-exclamation-circle"></i> {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        className="login-btn"
                        disabled={loading}
                    >
                        {loading
                            ? <><i className="fas fa-circle-notch fa-spin"></i> Вход...</>
                            : <><i className="fas fa-sign-in-alt"></i> Войти</>
                        }
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;

